import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import DynamicPagesListView from "./list";
import DynamicPageSingleView from "./single";

const DynamicPagesViews = () => {
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens for changes in the url and, when the path is the dynamic-pages base route,
     * redirects the user to the list page.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.userPlatform.dynamicPages.base, exact: true})) {
            history.replace(routes.userPlatform.dynamicPages.list);
        }
    }, [history, location.pathname]);

    return (
        <Switch>
            <Route path={[routes.userPlatform.dynamicPages.base, routes.userPlatform.dynamicPages.list]} exact>
                <DynamicPagesListView/>
            </Route>
            <Route path={routes.userPlatform.dynamicPages.single} exact>
                <DynamicPageSingleView/>
            </Route>
        </Switch>
    );
};

export default DynamicPagesViews;
